import { Box, Grid } from '@mui/material';
import { useEffect } from 'react';
import { TManagerForm } from '../type';
import { styles } from '~/modules/styles';
import { InformationBlockForm } from '~/modules/remote-banking-contacts/components/InformationBlockForm.tsx';
import { DocumentBlockForm } from '~/modules/remote-banking-contacts/components/DocumentBlockForm.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion.tsx';
import { PersonRole } from '~/modules/remote-banking-contacts/constants.tsx';

export const RemoteBankingContactsManagerForm = () => {
  const { setValue, control } = useFormContext<TManagerForm>();

  const [contragentType, havePersonalIdentifier, personalIdentifier] = useWatch({
    control,
    name: ['contragentType', 'havePersonalIdentifier', 'person.personalIdentifier'],
  });

  useEffect(() => {
    if (havePersonalIdentifier === false && contragentType === PersonRole.LEGAL_ENTITY) {
      setValue('person.personalIdentifier', null, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }

    if (havePersonalIdentifier) {
      setValue('person.documentInfo', null, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [havePersonalIdentifier, contragentType, setValue]);

  const personalIdentifierDisabled =
    !havePersonalIdentifier && contragentType === PersonRole.LEGAL_ENTITY;

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Grid container spacing={2}>
        <Grid sx={styles.checkboxWrapper}>
          <FormYesNoQuestion
            question="Зазначте тип клієнта"
            name="contragentType"
            labelYes="ЮО"
            valueYes={PersonRole.LEGAL_ENTITY}
            labelNo="ФОП"
            valueNo={PersonRole.SOLE_TRADER}
            onValueChange={({ event, fieldOnChange }) => {
              const rawValue = event.target.value;
              const isBoolean = rawValue === 'true' || rawValue === 'false';
              const value = isBoolean ? rawValue === 'true' : rawValue;
              fieldOnChange(value as string);
            }}
          />
          {contragentType === PersonRole.LEGAL_ENTITY && (
            <FormYesNoQuestion
              question={
                'Чи зареєстровані Ви у Державному реєстрі фізичних осіб - платників податків?'
              }
              name={'havePersonalIdentifier'}
              labelYes="Так (маю РНОКПП)"
              labelNo="Ні (відмовився(лась) від прийняття РНОКПП у встановленому законом порядку)"
            />
          )}
        </Grid>
        {contragentType === PersonRole.LEGAL_ENTITY && (
          <Grid size={{ xs: 12, sm: 6 }}>
            <FormInput
              fullWidth
              name="contragentIdentifier"
              label="ЄДРПОУ"
              placeholder="Введіть ЄДРПОУ"
              inputProps={{ maxLength: 8 }}
              onChange={() => {
                if ((contragentType as string) === PersonRole.SOLE_TRADER && personalIdentifier) {
                  setValue('contragentIdentifier', personalIdentifier, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                }
              }}
            />
          </Grid>
        )}
        {(contragentType === PersonRole.SOLE_TRADER ||
          contragentType === PersonRole.LEGAL_ENTITY) && (
          <Grid size={{ xs: 12, sm: 6 }}>
            <FormInput
              fullWidth
              name="person.personalIdentifier"
              label="РНОКПП керівника"
              placeholder="Введіть РНОКПП"
              inputProps={{ maxLength: 10 }}
              disabled={personalIdentifierDisabled}
              onChange={(e) => {
                if ((contragentType as string) === PersonRole.SOLE_TRADER) {
                  setValue('contragentIdentifier', e.target.value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                }
              }}
            />
          </Grid>
        )}
        <InformationBlockForm baseName="person" />
        {havePersonalIdentifier === false && contragentType === PersonRole.LEGAL_ENTITY && (
          <DocumentBlockForm />
        )}
      </Grid>
    </Box>
  );
};
